import styled from "styled-components";
import { DataGridRow, color, spacing } from "@conserveit/blocks";

export const EquipListRow = styled(DataGridRow)`
  cursor: default;
  overflow: visible !important;

  .Row-actions-snoozeIcon,
  .Row-actions-reportIcon,
  .Row-actions-actionIcon {
    display: inline-block;
    margin-right: ${spacing.tight};
  }
  &:hover {
    .Row-actions-snoozeIcon,
    .Row-actions-reportIcon,
    .Row-actions-actionIcon {
      opacity: 1;
    }
  }

  .Row-actions-reportIcon,
  .Row-actions-actionIcon {
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  }

  .Row-actions-snoozeIcon {
    opacity: ${({ isSnoozed, isActive }) => (isSnoozed || isActive ? 1 : 0)};
  }
`;

export const Icon = styled.div`
  display: inline-flex;
  height: 20px;
  width: 20px;
  min-height: 20px;
  min-width: 20px;
  fill: ${color.theme.icon.default};
`;
